import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6478ac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Contactgegevens", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Contacturen", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sociale media", -1))
const _hoisted_6 = { class: "social-links" }
const _hoisted_7 = {
  href: "https://www.facebook.com/computerinforbusiness",
  target: "_blank"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  href: "https://www.linkedin.com/company/computerinfor",
  target: "_blank"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  href: "https://github.com/Groamer",
  target: "_blank"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "copyright-section" }
const _hoisted_19 = { class: "container" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/algemene_voorwaarden" }, "Algemene voorwaarden", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/sitemap" }, "Sitemap", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.computerinfor.nl",
  target: "_blank"
}, "ComputerInfor", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_details_table = _resolveComponent("contact-details-table")!
  const _component_triple_block = _resolveComponent("triple-block")!
  const _component_opening_hours_table = _resolveComponent("opening-hours-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($props.displayContactDetails)
          ? (_openBlock(), _createBlock(_component_triple_block, { key: 0 }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_contact_details_table)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        ($props.displayOpeningHours)
          ? (_openBlock(), _createBlock(_component_triple_block, { key: 1 }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_opening_hours_table)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", _hoisted_7, [
                _createElementVNode("img", { src: $data.facebookLogo }, null, 8, _hoisted_8),
                _createElementVNode("img", { src: $data.facebookLogoActive }, null, 8, _hoisted_9)
              ]),
              _hoisted_10,
              _createElementVNode("a", _hoisted_11, [
                _createElementVNode("img", { src: $data.linkedinLogo }, null, 8, _hoisted_12),
                _createElementVNode("img", { src: $data.linkedinLogoActive }, null, 8, _hoisted_13)
              ]),
              _hoisted_14,
              _createElementVNode("a", _hoisted_15, [
                _createElementVNode("img", { src: $data.githubLogo }, null, 8, _hoisted_16),
                _createElementVNode("img", { src: $data.githubLogoActive }, null, 8, _hoisted_17)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createTextVNode(" | "),
        _hoisted_21,
        _createTextVNode(" | © 2021 - " + _toDisplayString($data.currentYear) + " MaatComputers | Ontwerp en ontwikkeling door ", 1),
        _hoisted_22
      ])
    ])
  ], 64))
}